var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import { has, set } from 'object-path';
import { curry } from './utils/fp';

export function augmentStore(createReducer, store) {
    store.injectedReducers = {};
    store.injectReducers = function injectReducers(reducers) {
        Object.entries(reducers).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                reducer = _ref2[1];

            if (!has(store.injectedReducers, key)) {
                set(store.injectedReducers, key, reducer);
                store.replaceReducer(createReducer(store.injectedReducers));
            }
        });
    };
    return store;
}

export default curry(augmentStore);